import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { BRAND, getCopyrightText } from '../constants/brand';

const Footer: React.FC = () => {
  const { language } = useLanguage();

  return (
    <footer className="bg-gray-900/50 backdrop-blur-sm border-t border-gray-700/30 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          {/* Logo */}
          <div className="flex items-center">
            <Link to={language === 'en' ? '/en' : '/'} className="inline-block">
              <img 
                src="/logo-no-background.svg" 
                alt={BRAND.COMPANY_NAME} 
                className="h-10 w-auto transition-all duration-300 hover:scale-105"
                style={{
                  filter: 'drop-shadow(0 0 10px rgba(170, 150, 218, 0.3))'
                }}
              />
            </Link>
          </div>

          {/* Copyright */}
          <div className="text-center">
            <p className="text-gray-400 text-sm">
              {getCopyrightText(language)}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
